export default __webpack_public_path__ + "static/media/IMG_8357.61e3ceaf.jpeg";